import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  formControl: {
    position: "relative",
    "& .MuiSelect-selectMenu": {
      padding: "12px 30px 12px 12px",
      fontWeight: 400,
      "& .extra-info": {
        margin: "0 16px 0 30px",
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#EDEDED",
    },
    "& legend": {
      width: 0,
    },
  },
  dotIndicator: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    background: "#ED7020",
    right: 5,
    top: 13,
    position: "absolute",
  },
  newUser: {
    background: "#FDF3EA !important",
    border: "solid 1px #E4CBB7",
  },
  extraInfo: {
    color: "#F3994E",
    margin: "0 33px 0 30px",
    float: "right",
  },
  starMark: {
    color: "#FF6D6D",
    marginLeft: 3,
  },
  InputLabel: {
    color: "#2E2E2E",
    position: "static",
    marginBottom: 8,
    fontSize: 14,
    transform: "none !important",
    fontWeight: 500,
    "&.Mui-focused": {
      color: "#000",
    },
    "& + .MuiInputBase-root": {
      marginTop: 0,
      fontFamily: "inherit",
      padding: 0,
      // background: "#FAFAFA",
      borderRadius: 4,
      "&:before": {
        border: "none",
      },
    },
  },
  selectEmpty: {
    fontSize: 14,
    fontWeight: 500,
    "& .MuiSelect-select": {
      "&:focus": {
        background: "none",
      },
    },
  },
  errorMessages: {
    color: "#F36F6F",
    fontSize: 13,
    marginTop: 3,
    display: "flex",
    "& svg": {
      fontSize: 18,
    },
  },
  placeholder: {
    color: "#a9a9a9",
    fontStyle: "normal",
    fontWeight: "normal",
  },
  menuItem: {
    display: "flex",
    justifyContent: "space-between",
    borderRadius: "0 !important",
    "&:first-child": {
      borderRadius: "4px 4px 0 0",
    },
    "&:last-child": {
      marginBottom: 0,
      borderRadius: "0 0 4px 4px",
    },
    "&.Mui-selected .avatar-img img": {
      filter: "unset !important",
    },
  },
  toggleBtnGroup: {
    flexWrap: "wrap",
    "& button": {
      borderRadius: "10px !important",
      margin: "0 6px 6px 0",
      padding: "10px 12px",
      height: 40,
      border: "solid 1px #F0F0F0 !important",
      color: "#2E2E2E",
      fontSize: 14,
      "&.Mui-selected": {
        color: "#2E2E2E",
        fontWeight: 500,
        boxShadow: "0px 1px 3px #00000029",
        borderBottom: "solid 3px #EF7713 !important",
        background: "none",
      },
    },
  },
}));

export default useStyles;
